import {Directive, HostListener, Input} from '@angular/core';
import {FormDataTrackingService} from '@app/services/analytics/form-data-tracking.service';
import {EventService, Product} from '@spartacus/core';
import {EddlFormViewEvent} from '@app/services/analytics/EDDL/events/eddl-form-view-event';

const leadFormActionType: string = 'popup';

export interface ShowFormButtonOptions {
  name: string;
  country?: string;
  useCustomTrigger?: boolean;
  product?: Product;
  productId?: string;
  actionType?: string;
}

@Directive({
  selector: '[dcpShowFormButton]'
})
export class ShowFormButtonDirective {

  @Input() dcpShowFormButton: ShowFormButtonOptions = {
    name: '',
    useCustomTrigger: false,
    actionType: ''
  };

  constructor(private formDataTrackingService: FormDataTrackingService,
              private eventService: EventService) {
  }

  @HostListener('click') onMouseEnter() {
    if (!this.dcpShowFormButton.useCustomTrigger) {
      this.triggerViewTrackingCall();
      this.triggerEddlFormViewEvent();
    }
  }

  /**
   * Sends form view data to adobe analytics. Is used to manually trigger the tracking when the {@code useCustomTrigger} option is active.
   */
  public triggerViewTrackingCall() {
    this.formDataTrackingService.trackFormView(
      this.dcpShowFormButton.name,
      this.dcpShowFormButton.country,
      this.dcpShowFormButton.product,
    );
  }

  /**
   * Sends lead form view EDDL event data to adobe analytics.
   * Is used to manually trigger the tracking when the {@code useCustomTrigger} option is active.
   * Is used to trigger the tracking when the {@code actionType} option is other than opening support form.
   */
  public triggerEddlFormViewEvent() {
    if (this.dcpShowFormButton?.actionType === leadFormActionType) {
      const event = new EddlFormViewEvent();
      event.name = this.dcpShowFormButton.name;
      if (this.dcpShowFormButton.product) {
        event.products = [];
        event.products.push({
          ID: this.dcpShowFormButton?.productId,
          name: this.dcpShowFormButton?.product?.name,
          partnerName: this.dcpShowFormButton?.product?.vendor?.name
        })
      }
      setTimeout(() => this.eventService.dispatch(event));
    }
  }
}
